import { createAsyncThunk, ThunkDispatch } from '@reduxjs/toolkit';
import notificationService from './NotificationService';
import { NotificationNew, NotificationParams } from './NotificationType';
import { errorHandlerThunk } from '../App/App.thunk';

export const getNotificationsListThunk = createAsyncThunk(
  'notifications/getNotificationsListThunk',
  async (params: NotificationParams, thunkApi) => {
    const response = await notificationService.getList(params);
    return response.data;
  },
);
export const getNotificationTypesThunk = createAsyncThunk(
  'notifications/getNotificationTypesThunk',
  async (_: undefined, thunkApi) => {
    const response = await notificationService.getTypes();
    return response.data;
  },
);
export const getNotificationCounterThunk = createAsyncThunk(
  'notifications/getNotificationTypesThunk',
  async (_: undefined, thunkApi) => {
    const response = await notificationService.getCounter();
    return response.data;
  },
);

export const saveNotificationThunk =
  (data: NotificationNew) => (dispatch: ThunkDispatch<any, any, any>) => {
    return notificationService
      .create(data)
      .then(() => {
        return true;
      })
      .catch((error: any) => {
        dispatch(errorHandlerThunk(error));
        return false;
      });
  };

export const markAsReadNotificationThunk =
  (id: string) => (dispatch: ThunkDispatch<any, any, any>) => {
    return notificationService
      .markAsRead(id)
      .then(() => {
        return true;
      })
      .catch((error: any) => {
        dispatch(errorHandlerThunk(error));
        return false;
      });
  };

export const markAllAsReadNotificationThunk =
  () => (dispatch: ThunkDispatch<any, any, any>) => {
    return notificationService
      .markAllAsRead()
      .then(() => {
        return true;
      })
      .catch((error: any) => {
        dispatch(errorHandlerThunk(error));
        return false;
      });
  };

export const removeNotificationThunk =
  (id: string) => (dispatch: ThunkDispatch<any, any, any>) => {
    return notificationService
      .remove(id)
      .then(() => true)
      .catch((error: any) => {
        dispatch(errorHandlerThunk(error));
        return false;
      });
  };

export const removeAllReadNotificationThunk =
  () => (dispatch: ThunkDispatch<any, any, any>) => {
    return notificationService
      .removeAllRead()
      .then(() => true)
      .catch((error: any) => {
        dispatch(errorHandlerThunk(error));
        return false;
      });
  };
